// @ts-check
import React from 'react';
import { Flex, Padding } from 'components/base/layout-components';
import { LINE_HEIGHT } from 'common/constants/sizes';
import Text from 'components/base/Text';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import { isAdmin } from 'common/services/accounts.service';
import {
  LBButton,
  LBLabel,
  LBRadioGroup,
  LBRadioGroupItem
} from '@linearb/buzz';

const ACCOUNTS_TYPES_DESCRIPTION = {
  [ACCOUNT_TYPES_MAP.Viewer]: 'Viewer - has read-only rights',
  [ACCOUNT_TYPES_MAP.Editor]: 'Editor - has partial editing rights',
  [ACCOUNT_TYPES_MAP.Primary]: 'Admin - has full administrative rights'
};

const getLabel = label => <Text size='large'>{label}</Text>;
const getControlLabel = accountType => (
  <div className='flex flex-row gap-2'>
    <LBRadioGroupItem
      data-testid={`${accountType}-form-control-label-testid`}
      value={accountType}
      id={accountType}
    />
    <LBLabel htmlFor={accountType}>
      {getLabel(ACCOUNTS_TYPES_DESCRIPTION[accountType])}
    </LBLabel>
  </div>
);

const ChangeUserTypeModal = ({
  myAccount,
  typeId,
  displayName,
  toggleModal,
  onAccountTypeChanged
}) => {
  const isCurrentUserAdmin = isAdmin(myAccount);
  const [selectedTypeId, setSelectedTypeId] = React.useState(typeId);

  const accountTypesOptions = [
    getControlLabel(ACCOUNT_TYPES_MAP.Viewer),
    getControlLabel(ACCOUNT_TYPES_MAP.Editor),
    ...(isCurrentUserAdmin ? [getControlLabel(ACCOUNT_TYPES_MAP.Primary)] : [])
  ];

  return (
    <Flex direction='column' padding='medium'>
      <Flex pb='small' items='center'>
        <Text size='x-x-large'>Set user role</Text>
      </Flex>
      <Flex items='center'>
        <Text size='large' lineHeight={LINE_HEIGHT.large}>
          Set the desired user role for {displayName}
        </Text>
      </Flex>
      <Padding t='medium' b='medium'>
        <LBRadioGroup value={selectedTypeId} onValueChange={setSelectedTypeId}>
          {accountTypesOptions.map(item => item)}
        </LBRadioGroup>
      </Padding>
      <Flex items='center' justify='flex-end'>
        <LBButton variant='outline' onClick={() => toggleModal()}>
          Cancel
        </LBButton>
        <Padding l='small'>
          <LBButton
            data-testid='set-role-button-testid'
            disabled={typeId === selectedTypeId}
            onClick={() => onAccountTypeChanged(selectedTypeId)}
          >
            Set role
          </LBButton>
        </Padding>
      </Flex>
    </Flex>
  );
};

export default ChangeUserTypeModal;
